import React from 'react'
import ProductsList from '../components/ProductsList'

export default function Products() {
  return (
    <div>
        <ProductsList/>
    </div>
  )
}
